import { LogLevel, LogType } from "./contracts";
import { logServiceDefaultOptions } from "./default-options/LogServiceDefaultOptions";
import { LocalStorage } from "@Core/storages/local/LocalStorage";
import { eventsService } from "@Core/events";
import { AppEvents } from "@Core/constants/AppEvents";
export class LogService {
    constructor() {
        this.logHistory = [];
        this.logOptionsKey = "__appLogsOptions__";
        this.logOptions = { ...logServiceDefaultOptions };
        this.storage = new LocalStorage();
        const storedOptions = this.storage.get(this.logOptionsKey);
        storedOptions && (this.logOptions = { ...this.logOptions, ...storedOptions });
        this.storage.set(this.logOptionsKey, this.logOptions);
    }
    setOptions(logOptions) {
        this.logOptions = Object.assign(this.logOptions, logOptions);
        this.storage.set(this.logOptionsKey, this.logOptions);
    }
    getOptions() {
        return this.logOptions;
    }
    getLogHistory() {
        return [...this.logHistory];
    }
    message(text, type = LogType.Log, level = LogLevel.Low) {
        text = Array.isArray(text) ? text : [text];
        const logMessage = `>>>> ${type.toUpperCase()} <<<< |`;
        this.logHistory.push(`${logMessage} ${(text)}`);
        if (this.logOptions.debug && level >= this.logOptions.level) {
            window.console[type](logMessage, ...text);
        }
    }
    log(...args) {
        this.message(args, LogType.Log, LogLevel.Low);
    }
    warn(...args) {
        this.message(args, LogType.Warn, LogLevel.Medium);
    }
    error(...args) {
        eventsService.dispatch(AppEvents.GenericError, args);
        eventsService.dispatch(AppEvents.NxtError, args);
        this.message(args, LogType.Error, LogLevel.High);
    }
}
export const logService = new LogService();
